export const ORDERS_RESULT_COLUMN_SELECTOR = '.search-orders-section-a-orders';

export const SEARCH_ORDERS_HEADING_SELECTOR = '.search-orders-page-heading';

export const SEARCH = () => ({
  orderId: '',
  startDate: '',
  endDate: '',
  firstName: '',
  lastName: '',
});

export const SEARCHED_ORDER = () => ({
  DOB: '',
  DoctorId: 0,
  FirstName: '',
  LastName: '',
  OrderId: '',
  ProductName: '',
  State: '',
  StoreFrontName: '',
  StorefrontId: 0,
  UserId: 0,
  VisitType: 1,
});
